import * as App from '../../app';
import bridge from '@vkontakte/vk-bridge';
export function initVkBanner() {
    if (FOR_VK) {
        // https://dev.vk.com/bridge/VKWebAppShowBannerAd
        if (window.innerHeight / window.innerWidth > 2) {
            bridge
                // @ts-ignore
                .send('VKWebAppShowBannerAd', { banner_location: 'bottom', layout_type: 'resize', can_close: false })
                .then(function () {
                App.stat.params({ banner: { ok: 1 } });
            })
                .catch(function (err) {
                App.stat.params({ banner: { error: 1 } });
            });
        }
        else {
            App.stat.params({ banner: { smallScreen: 1 } });
        }
    }
}
